
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import Subscription from '@/extend/classes/Subscription';
import { storeSession } from '@/generated/stores';
import HubServices from "@/generated/hub/HubServices";
import ListData, { ListItem, ColumnConfig, ListConfig, ListFilter } from '@/extend/classes/ListData';
import { Alerts } from '@/framework/base/helpers/Alerts';

import { v4 as uuidv4 } from 'uuid';


@Module({ name: 'storeSubscription' })

export default class storeSubscription extends VuexModule {
  // States
  private reccords: Subscription[] = [];
  private config : ColumnConfig[] = [];
  private idsLoading: number[] = [];
  private dataLoading = false;
  private dataLoaded = false;
  private dataRegistered = false;

  // Getters on states for asynchronous actions
  private get subscriptionLoading (): boolean {
    return this.dataLoading;
  }
  private get subscriptionRegistered (): boolean {
    return this.dataRegistered;
  }

  
  public get subscriptionLoaded (): boolean {
    return this.dataLoaded;
  }

  public get createNewSubscription() {
    return (): Subscription => { 
      return this.getSubscription(0, true);
    }
  }

  
  public get getSubscription () {
    return (id: number, canCreate = false): Subscription => {
      if (id == 0 && !canCreate) {
        Alerts.debug("Id Subscription can't be 0")
        return new Subscription();
      }
      const res = this.reccords.find(c => c.id == id);
      if (res != undefined) {
        return res;
      } else {
        const copy = new Subscription();
        if (id == 0) {
          if (this.reccords.length == 0) {
            copy.id = -1;
          } else {
            this.reccords.sort((a, b) => (a.id - b.id));
            copy.id = Math.min(-1, this.reccords[0].id - 1);
          }          copy.canDelete = true;          copy.canUpdate = true;
          copy.createId = uuidv4();
          this.reccords.push(copy);
        } else if (id > 0) {
          copy.id = id;
          this.reccords.push(copy);
          if (storeSession.httpCx != undefined && !this.idsLoading.includes(id)) {
            this.idsLoading.push(id);
            Subscription.getForStore(id).then((data: ListData) => {
              const tmpCopy = this.reccords.find(a => a.id == id);
              if (tmpCopy) {
                tmpCopy.fromSubscription(data.reccords[0] as Subscription);
              }
              const config = data.config as ListConfig
              if (this.config.length == 0) {
                config.columnsConfig.forEach((column) => {
                  this.config.push(column);
                })
              } else {
                config.columnsConfig.forEach((column) => {
                  if (column.choix.length == 1) {
                    const columnConfig = this.config.find(a => a.name == column.name);
                    if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
                      const columnChoix = columnConfig.choix;
                      const newChoix = column.choix[0];
                      columnChoix.push(newChoix);
                    }
                  }
                });
              }
              const index = this.idsLoading.findIndex(x => x == id);
              if (index >= 0) {
                this.idsLoading.splice(index, 1);
              }
            })
          }
        }
        return copy
      }
    }
  }


  

  public get listSubscription (): Subscription[] {
    return this.reccords;
  }

  public get listConfigSubscription (): ColumnConfig[] {
    return this.config;
  }


  @Mutation
  private mSubscriptionRegistered (): void {
    this.dataRegistered = true;
  }

  @Mutation
  public mSubscriptionClearData (): void {
    this.reccords = [];
    this.idsLoading = [];
    this.dataLoading = false;
    this.dataLoaded = false;
    this.dataRegistered = false;
  }

  @Mutation
  private mSubscriptionLoading (value: boolean): void {
    this.dataLoading = value;
  }

  @Mutation
  private mSubscriptionLoaded (data: ListData): void {
    this.dataLoaded = true;
    this.idsLoading.splice(0, this.idsLoading.length);
    this.reccords = [];
    data.reccords.forEach((reccord) => {
      this.reccords.push(Subscription.fromJson(reccord as Subscription));
    })
    Subscription.getDate(this.reccords);
    this.config = data.config.columnsConfig;
  }

  @Mutation
  private mSubscriptionConfigUpdated (newConfig: ListConfig): void {
    newConfig.columnsConfig.forEach((column) => {
      if (column.choix.length == 1) {
        const columnConfig = this.config.find(a => a.name == column.name);
        if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
          const columnChoix = columnConfig.choix;
          const newChoix = column.choix[0];
          columnChoix.push(newChoix);
          console.log(newChoix);
        }
      }
    });
  }

  @Mutation
  public mSubscriptionCreated (obj: Subscription): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      let api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareSubscription(obj)) {
          api.fromSubscription(obj);
        }
      } else {
        api = this.reccords.find(x => x.createId == obj.createId && obj.createId != null && obj.createId != '');
        if (api) {
          if (!api.compareSubscription(obj)) {
            api.fromSubscription(obj);
          } else if (api.id != obj.id ) {
            api.id = obj.id;
          }
        } else {
          this.reccords.push(obj);
        }
      }
    }
  }

  @Mutation
  public mSubscriptionUpdated (obj: Subscription): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      const api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareSubscription(obj)) {
          api.fromSubscription(obj);
        }
      } else {
        this.reccords.push(obj);
      }
    }
  }

  @Mutation
  public mSubscriptionDeleted (id: number): void {
    const index = this.reccords.findIndex(x => x.id == id);
    if (index >= 0) {
      this.reccords.splice(index, 1);
    }
  }

    
  @Action
  public registerSubscription (filter: ListFilter | null = null): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.subscriptionRegistered && storeSession.hubUsed) {
        if (HubServices.hubReady()) {
          HubServices.registerSubscription(this.subscriptionCreated, this.subscriptionUpdated, this.subscriptionDeleted);
          this.mSubscriptionRegistered();
        } else {
          setTimeout(() => resolve(this.registerSubscription(filter)), 1000);
        }
      }
      if (filter != null) {
        if (HubServices.hubReady() && !this.subscriptionLoading && !this.subscriptionLoaded) {
          this.mSubscriptionLoading(true);
          return Subscription.list(filter)
            .then((data: ListData) => {
              this.mSubscriptionLoaded(data);
              this.mSubscriptionLoading(false);
              resolve(true);
            })
        }
      } else  {
        resolve(true);
      }
  })
}


  @Action
  public listFilteredSubscription (filter: ListFilter): Promise<boolean> {
    return new Promise((resolve) => {
      if (HubServices.hubReady() && !this.subscriptionLoading) {
        this.mSubscriptionLoading(true);
        return Subscription.list(filter)
          .then((data: ListData) => {
            this.mSubscriptionLoaded(data);
            this.mSubscriptionLoading(false);
            resolve(true);
          })
      }
    })
  }


  
  @Action
  public createSubscription (obj: Subscription): Promise<Subscription> {
    return new Promise((resolve, reject) => {
      return Subscription.fromJson(obj).createForStoreSubscription()
        .then((reccords) => {
          this.mSubscriptionCreated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  public updateSubscription (obj: Subscription): Promise<Subscription> {
    return new Promise((resolve, reject) => {
      return Subscription.fromJson(obj).updateForStoreSubscription()
        .then((reccords) => {
          this.mSubscriptionUpdated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }
  
  @Action
  private subscriptionCreated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mSubscriptionConfigUpdated(config)
    const obj = objConfig.obj as Subscription;
    this.mSubscriptionCreated(Subscription.fromJson(obj));
  }

  @Action
  private subscriptionUpdated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mSubscriptionConfigUpdated(config)
    const obj = objConfig.obj as Subscription;
    this.mSubscriptionUpdated(Subscription.fromJson(obj));
  }

  @Action
  private subscriptionDeleted (objConfig: ListItem): void {
    const obj = objConfig.obj as Subscription;
    this.mSubscriptionDeleted(obj.id);
  }
}
